import { AbiDefinition } from 'ethereum-types'
import { apiEndpoint } from './config'

const Web3 = require('web3')

const provider = new Web3.providers.HttpProvider(apiEndpoint)

const web3 = new Web3(provider)

// Having this separated should make testing of fetchBalance() easier (mocking will be simpler)
export const buildContract = (abi: AbiDefinition[], tokenAddress: string) =>
  new web3.eth.Contract(abi, tokenAddress)

export default buildContract
